import React from 'react'
import { Card, Form, Row, Col, Alert } from 'react-bootstrap'
import './FacturacionTab.css'

function FacturacionTab({
	datosFacturacion = {},
	datosOriginales = {},
	onChange,
	disabled = false,
	showPaymentWarning = false,
	erroresValidacion = {}
}) {
	const handleChange = (campo, valor) => {
		onChange(campo, valor)
	}

	// Verificar si hay cambios pendientes
	const hayCambiosPendientes = () => {
		if (!datosFacturacion) return false

		const razonSocialCambio = datosFacturacion.razonSocial !== (datosOriginales.razonSocial || '')
		const rucCambio = datosFacturacion.ruc !== (datosOriginales.ruc || '')

		return razonSocialCambio || rucCambio
	}

	return (
		<Card className="shadow-sm">
			<Card.Header className="bg-light">
				<h6 className="mb-0">
					<i className="fa fa-file-invoice me-2"></i>
					Datos de Facturación
					{disabled && showPaymentWarning && (
						<i className="fa fa-lock ms-2 text-warning" title="Datos bloqueados - Pedido pagado"></i>
					)}
				</h6>
			</Card.Header>
			<Card.Body>
				{showPaymentWarning && disabled && (
					<Alert variant="warning" className="mb-3">
						<i className="fa fa-exclamation-triangle me-2"></i>
						<strong>Pedido pagado:</strong> Los datos de facturación no pueden modificarse una vez que el pedido ha sido pagado.
						Si necesita hacer cambios, gestione la devolución/reembolso por fuera de la plataforma.
					</Alert>
				)}

				<Form>
					<Row>
						<Col md={6}>
							<Form.Group className="mb-3">
								<Form.Label>
									Razón Social
									{disabled && showPaymentWarning && (
										<i className="fa fa-lock ms-1 text-muted facturacion-lock-icon"></i>
									)}
								</Form.Label>
								<Form.Control
									type="text"
									value={datosFacturacion?.razonSocial || ''}
									onChange={(e) => handleChange('razonSocial', e.target.value)}
									disabled={disabled}
									placeholder="Nombre o razón social del cliente"
									maxLength={200}
									isInvalid={!!erroresValidacion.razonSocial}
								/>
								<Form.Control.Feedback type="invalid">
									{erroresValidacion.razonSocial}
								</Form.Control.Feedback>
								<Form.Text className="text-muted">
									Máximo 200 caracteres. Opcional.
								</Form.Text>
							</Form.Group>
						</Col>

						<Col md={6}>
							<Form.Group className="mb-3">
								<Form.Label>
									RUC
									{disabled && showPaymentWarning && (
										<i className="fa fa-lock ms-1 text-muted facturacion-lock-icon"></i>
									)}
								</Form.Label>
								<Form.Control
									type="text"
									value={datosFacturacion?.ruc || ''}
									onChange={(e) => handleChange('ruc', e.target.value)}
									disabled={disabled}
									placeholder="12345678-9"
									maxLength={12}
									isInvalid={!!erroresValidacion.ruc}
								/>
								<Form.Control.Feedback type="invalid">
									{erroresValidacion.ruc}
								</Form.Control.Feedback>
								<Form.Text className="text-muted">
									Formato: 12345678-9. Opcional.
								</Form.Text>
							</Form.Group>
						</Col>
					</Row>

					{/* Mostrar datos originales si existen y son diferentes */}
					{(datosOriginales.razonSocial || datosOriginales.ruc) && (
						<div className="facturacion-datos-originales">
							<h6 className="mb-2">
								<i className="fa fa-info-circle me-1"></i>
								Datos Originales:
							</h6>
							<Row>
								{datosOriginales.razonSocial && (
									<Col md={6}>
										<small className="text-muted">Razón Social Original:</small>
										<div className="facturacion-dato-original">{datosOriginales.razonSocial}</div>
									</Col>
								)}
								{datosOriginales.ruc && (
									<Col md={6}>
										<small className="text-muted">RUC Original:</small>
										<div className="facturacion-dato-original">{datosOriginales.ruc}</div>
									</Col>
								)}
							</Row>
						</div>
					)}

					{/* Mostrar cambios pendientes si los hay */}
					{hayCambiosPendientes() && (
						<Alert variant="info" className="facturacion-cambios-pendientes">
							<i className="fa fa-edit me-2"></i>
							<strong>Cambios pendientes:</strong> Los datos de facturación han sido modificados y se guardarán al confirmar los cambios del pedido.
						</Alert>
					)}

					{/* Información adicional */}
					<div className="facturacion-info-adicional">
						<small className="text-muted">
							<i className="fa fa-info-circle me-1"></i>
							<strong>Nota:</strong> Los datos de facturación son opcionales y se utilizan únicamente para la emisión de facturas cuando el cliente lo requiera.
						</small>
					</div>
				</Form>
			</Card.Body>
		</Card>
	)
}

export default FacturacionTab